import React, { Component } from 'react';
import { postReq } from '../api/restHelper';
import { browserHistory } from 'react-router';
import { Formik } from 'formik';

class Activateform extends Component {

    render() {
        return (
            <div className="login-page-forms">
                <h4>کد فعال سازی را وارد نمایید</h4>
                <Formik
                    initialValues={{
                        code: ''
                    }}
                    validate={ values => {
                        let errors = {};
                        if (!values.code) {
                            errors.code = 'وارد کردن کد تایید الزامی است';
                        } else if (
                        !/^[0-9]{5}$/i.test(values.code.toEnglishDigits())
                        ) {
                        errors.code = 'کد تایید وارد شده معتبر نیست';
                        }
                        return errors;
                    }}
                    onSubmit = {( values, actions) => {
                        postReq({
                            code: values.code.toEnglishDigits(),
                            phone_number: this.props.phone
                        },'user/activate', (res)=>{
                            this.props.changeStatus(3)
                            var loginTime = new Date();
                            var appData = res.data;
                            appData.login_time = Math.floor(loginTime.getTime()/1000);
                            appData = JSON.stringify(appData);
                            localStorage.appData = appData
                            browserHistory.push('/app');
                        }, (err)=>{
                            actions.setSubmitting(false);
                        });
                    }}
                    render = { ({values, errors, touched, handleChange, handleSubmit, isSubmitting}) => (
                        <form name="activationForm" onSubmit={handleSubmit}>
                            <div className="content">
                                <div className="form-group">
                                    <input type="text" title="کد فعال سازی" placeholder="کد فعال سازی" name="code" value={values.code} onChange={handleChange} className="text-center" dir="ltr"/>
                                    <div className="form-error"> {(touched.code && errors.code) ? (errors.code):(null)} </div>
                                </div>
                            </div>
                            <div className="footer text-center">
                                <button type="submit" disabled={isSubmitting}>ارسال</button>
                            </div>
                        </form>
                    )}/>
            </div>
        );
    }
}

export default Activateform;